export const CONFIRMBOX_OPEN = "CONFIRMBOX/OPEN";
export const CONFIRMBOX_CLOSE = "CONFIRMBOX/CLOSE";

const ALL = {
  CONFIRMBOX_OPEN,
  CONFIRMBOX_CLOSE,
};
export default ALL;
